import React from "react";

const Bash_Zip = () => {
  return (
    <div className="p-6 max-w-3xl mx-auto">
      <h2 className="text-2xl font-semibold mb-2">Bash Zip</h2>
      <p>Package and compress files into a .zip archive.</p>
      <h4 className="font-medium mt-4">Syntax</h4>
      <pre><code>zip [options] archive.zip files...</code></pre>
      <h4 className="font-medium mt-4">Examples</h4>
      <pre><code>zip -r archive.zip folder/
zip file.zip file1 file2</code></pre>
      <h4 className="font-medium mt-4">Notes</h4>
      <p>Common on cross-platform sharing.</p>
    </div>
  );
};

export default Bash_Zip;
